// =============================================================================
// Child theme entry — client-specific JS.
// The parent theme (ai-zippy) handles core behaviors; this file adds LightChic
// features that don't belong in core (currently: the Wishlist page renderer).
// =============================================================================

const WISHLIST_KEY = "lc_wishlist";

function getWishlist() {
	try {
		return JSON.parse(localStorage.getItem(WISHLIST_KEY) || "[]");
	} catch (e) {
		return [];
	}
}

function saveWishlist(ids) {
	localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
	window.dispatchEvent(new CustomEvent("lc:wishlist-change"));
}

function wishlistCard(p) {
	const img = p.images && p.images[0] ? p.images[0].src : "";
	const cat =
		p.categories && p.categories[0] ? p.categories[0].name : "LightChic";
	return (
		'<div class="lc-wishlist__card" data-id="' + p.id + '">' +
		'<a class="lc-wishlist__art" href="' + p.permalink + '">' +
		(img ? '<img src="' + img + '" alt="' + p.name + '" loading="lazy" />' : "") +
		"</a>" +
		'<p class="lc-wishlist__cat">' + cat + "</p>" +
		'<a class="lc-wishlist__name" href="' + p.permalink + '">' + p.name + "</a>" +
		'<div class="lc-wishlist__price">' + (p.price_html || "") + "</div>" +
		'<div class="lc-wishlist__actions">' +
		'<a class="lc-wishlist__btn lc-wishlist__btn--view" href="' + p.permalink + '">View</a>' +
		'<button class="lc-wishlist__remove" type="button" data-remove="' + p.id + '" aria-label="Remove from wishlist">&times;</button>' +
		"</div>" +
		"</div>"
	);
}

async function renderWishlist(container) {
	const ids = getWishlist();

	if (!ids.length) {
		container.innerHTML =
			'<div class="lc-wishlist__empty">' +
			"<h2>Your wishlist is empty</h2>" +
			"<p>Tap the heart on any piece to save it here for later.</p>" +
			'<a class="lc-wishlist__shop" href="/shop/">Browse the collection</a>' +
			"</div>";
		return;
	}

	container.innerHTML = '<div class="lc-wishlist__loading">Loading your saved pieces…</div>';

	try {
		const res = await fetch(
			"/wp-json/wc/store/v1/products?per_page=100&include=" + ids.join(","),
		);
		const products = await res.json();

		if (!Array.isArray(products) || !products.length) {
			container.innerHTML =
				'<div class="lc-wishlist__empty"><h2>Your wishlist is empty</h2>' +
				'<a class="lc-wishlist__shop" href="/shop/">Browse the collection</a></div>';
			return;
		}

		container.innerHTML =
			'<div class="lc-wishlist__grid">' +
			products.map(wishlistCard).join("") +
			"</div>";

		container.querySelectorAll("[data-remove]").forEach((btn) => {
			btn.addEventListener("click", () => {
				const id = Number(btn.getAttribute("data-remove"));
				saveWishlist(getWishlist().filter((i) => i !== id));
				renderWishlist(container);
			});
		});
	} catch (e) {
		container.innerHTML =
			'<div class="lc-wishlist__empty"><p>We couldn\'t load your wishlist right now. Please try again.</p></div>';
	}
}

function boot() {
	const container = document.querySelector("[data-lc-wishlist-page]");
	if (container) {
		renderWishlist(container);
		window.addEventListener("lc:wishlist-change", () =>
			renderWishlist(container),
		);
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
// =============================================================================
// Child theme entry — client-specific JS goes here.
// The parent theme (ai-zippy) handles core behaviors; use this file only for
// client overrides or new features that don't belong in core.
// =============================================================================

// Example:
// import "./modules/client-hero.js";

console.log("[ai-zippy-child] loaded");
